import { SxProps, Theme } from '@mui/material/styles';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const styles = {
	accordionContainer: {
		marginTop: '20px',
		border: '1px solid #ddd',
		borderRadius: '8px',
		boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
	} as SxProps<Theme>,

	accordionDetails: {
		padding: '16px',
	} as SxProps<Theme>,

	downloadablesSection: {
		marginBottom: '20px',
		display: 'flex',
		flexWrap: 'wrap',
	} as SxProps<Theme>,

	downloadableItem: {
		border: '1px solid #ccc',
		borderRadius: '4px',
		marginBottom: '8px',
		flex: 1,
	} as SxProps<Theme>,

	downloadLink: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '10px 15px',
		textDecoration: 'none',
		color: 'inherit',
	} as SxProps<Theme>,

	downloadContent: {
		display: 'flex',
		alignItems: 'center',
	} as SxProps<Theme>,

	fileIcon: {
		marginRight: '8px',
		color: '#666',
	} as SxProps<Theme>,

	fileName: {
		fontWeight: OpenSansFontWeights.semibold,
		color: '#333',
	} as SxProps<Theme>,

	downloadAction: {
		display: 'flex',
		alignItems: 'center',
	} as SxProps<Theme>,

	downloadIcon: {
		color: 'secondary.main',
		marginRight: '4px',
	} as SxProps<Theme>,

	downloadText: {
		color: 'secondary.main',
		fontSize: '0.8rem',
	} as SxProps<Theme>,

	imageSection: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	} as SxProps<Theme>,

	productImage: {
		borderRadius: '8px',
	} as SxProps<Theme>,

	productDescription: {
		lineHeight: 1.6,
		color: '#555',
		whiteSpace: 'pre-wrap',
	} as SxProps<Theme>,

	infoFeedbackPDP: {
		position: 'static',
	} as SxProps<Theme>,

	feedbackForm: {
		position: 'relative',
		background: 'white',
		padding: '15px',
		boxSizing: 'border-box',
		zIndex: 100,
		width: {
			xs: 'calc(100% - 32px',
			sm: '320',
			md: '30vw',
		},
		maxWidth: '100%',
		marginTop: '5px',
	} as SxProps<Theme>,

	feedbackForm__inputs: {
		width: '100%',
	} as SxProps<Theme>,

	feedbackForm__inputsData: {
		width: '100%',
		boxSizing: 'border-box',
		marginBottom: '10px',
		border: '1px solid #ccc',
	} as SxProps<Theme>,

	drawContainer: {
		width: {
			xs: '90%',
			sm: '85%',
			md: '40%',
		},
	},

	drawerFormContainer: {
		position: 'relative',
		background: 'white',
		padding: '15px',
		boxSizing: 'border-box',
		width: '100%', // Controlled by PaperProps
		marginTop: '5px',
	},
	drawerFormHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 48,
		position: 'relative',
		borderBottom: '1px solid #ddd',
		marginBottom: '15px',
	},
	drawerFormTextArea: {
		width: '100%',
		boxSizing: 'border-box',
		padding: '12px',
		marginBottom: '10px',
		border: '1px solid #ccc',
		borderRadius: '4px', // Add some styling to match MUI
		fontFamily: 'inherit',
	},
	accordionSummary: {
		p: { sm: '10px', md: '0' },
		'& .MuiAccordionSummary-content': {
			margin: 0,
		},
		'&.MuiAccordionSummary-gutters': {
			paddingLeft: 0,
			paddingRight: 0,
		},
	},
	msgSuccess: {
		mt: 2,
		display: 'block',
		color: 'success.main',
	},
	msgError: {
		mt: 2,
		display: 'block',
		color: 'error.main',
	},
};
